import { gql } from '@apollo/client';

export const fetchIGPurchaseOrderInPPC = gql`
  query fetchIGpurchaseOrderInPPC($id: ID!, $txaId: ID) {
    invoiceGroup(id: $id, txaId: $txaId) {
      id
      purchaseOrder {
        number
        oneTimeUse
      }
    }
  }
`;
